import { splitProps, type Component, type JSX } from 'solid-js';

function mergeClasses(...classes: (string | undefined)[]): string {
    return classes.filter(Boolean).join(' ');
}

export interface BadgeProps {
    selected?: boolean;
    // Hover invert, on by default. Turn it off for a badge that is a static
    // label: an affordance on something that does not respond to a click reads
    // as a broken control.
    interactive?: boolean;
    class?: string;
    children?: JSX.Element;
    [key: string]: any;
}

const Badge: Component<BadgeProps> = (props) => {
    const [local, others] = splitProps(props, ['selected', 'interactive', 'class', 'children']);

    const idle = () => (local.interactive === false ? 'bg-muted' : 'bg-muted hover:bg-foreground hover:text-background');

    const classes = () => mergeClasses('font-medium rounded px-2 py-0.5 w-fit shrink-0', local.selected ? 'bg-foreground text-background' : idle(), local.class);

    return (
        <div class={classes()} {...others}>
            {local.children}
        </div>
    );
};

export { Badge };
